import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["labelledBy", "className", "isNav", "onClose", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
var propTypes = {
  /** Additional styling */
  className: PropTypes.string,
  /** Used with OverflowMenu `isNav` */
  isNav: PropTypes.bool,
  /**  */
  onClose: PropTypes.func,
  /** Used with OverflowMenu `isNav` */
  labelledBy: PropTypes.string,
  /** OverflowMenuOption components  */
  children: PropTypes.node.isRequired
};
var defaultProps = {
  className: undefined,
  isNav: false,
  onClose: function onClose() {},
  labelledBy: undefined
};
var OverflowMenuOptionList = function OverflowMenuOptionList(_ref) {
  var labelledBy = _ref.labelledBy,
    className = _ref.className,
    isNav = _ref.isNav,
    onClose = _ref.onClose,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var overflowMenu = useRef(null);
  var styleClass = classnames('wds-c-overflow-menu__options', className);
  var optionListItems = React.Children.toArray(children);
  if (optionListItems.length > 0) {
    /* set the isFirst prop for the first child in the list */
    optionListItems = [/*#__PURE__*/React.cloneElement(optionListItems[0], {
      isFirst: true
    })].concat(optionListItems.slice(1));
  }
  var onArrowKey = function onArrowKey(event) {
    event.preventDefault(); /* Prevents the page from scrolling on arrow key press */
    var overflowMenuOption = event.target.closest('li'); /* Find the closest item to the selected option */
    var overflowMenuOptions = _toConsumableArray(overflowMenu.current.querySelectorAll('li')); /* Get a list of all the options in the list */

    var direction = {
      /* set the loop position change */38: -1 /* go back one position for up key */,
      40: 1 /* go forward one position for down key */
    }[event.which];
    var nextIndex = Math.max(overflowMenuOptions.indexOf(overflowMenuOption) + direction, -1);
    var loopedNextIndex = nextIndex >= 0 && nextIndex < overflowMenuOptions.length ? nextIndex : nextIndex - ((nextIndex > 0) - (nextIndex < 0) || +nextIndex) * overflowMenuOptions.length;
    if (nextIndex >= overflowMenuOptions.length) {
      loopedNextIndex = 0;
    }
    var nextOverflowMenuOptionsListItem = overflowMenuOptions[loopedNextIndex];
    var focusTarget = nextOverflowMenuOptionsListItem.querySelector('button') || nextOverflowMenuOptionsListItem.querySelector('a');
    if (focusTarget) {
      focusTarget.focus();
    }
  };
  var onKeydown = useCallback(function (event) {
    switch (event.which) {
      case 9 /* Tab key pressed */:
        if (!isNav) {
          /* if is not nav, close the menu */
          onClose();
        }
        break;
      case 38: /* Up arrow key */
      case 40 /* and down key */:
        onArrowKey(event);
        break;
      case 27 /* when escape key is pressed */:
        onClose();
        break;
      default:
        break;
    }
  }, [isNav]);
  var onClick = useCallback(function (event) {
    if (event.target && event.target.hasAttribute('data-nav-close')) {
      onClose();
    }
  });
  useEffect(function () {
    document.addEventListener('keydown', onKeydown, false);
    document.addEventListener('click', onClick, false);
    return function () {
      /* Remove keydown event listeners on cleanup */
      document.removeEventListener('keydown', onKeydown, false);
      document.removeEventListener('click', onClick, false);
    };
  }, []);
  return /*#__PURE__*/React.createElement("ul", _extends({
    ref: overflowMenu
  }, !isNav ? {
    role: 'menu',
    'aria-labelledby': labelledBy
  } : {
    tabIndex: -1
  }, {
    className: styleClass
  }, otherProps), optionListItems);
};
OverflowMenuOptionList.propTypes = propTypes;
OverflowMenuOptionList.defaultProps = defaultProps;
OverflowMenuOptionList.displayName = 'OverflowMenuOptionList';
export default OverflowMenuOptionList;